import { Label, Textarea } from '@creanizer/ui'
import { Alert, AlertDescription } from '@creanizer/ui'
import { Info } from 'lucide-react'
import type { WorldBuilderInput, WorldPreset } from '@creanizer/types'
import { WORLD_PRESETS } from '../constants/presets'

interface PresetModeFormProps {
  input: WorldBuilderInput
  onChange: (input: WorldBuilderInput) => void
}

export function PresetModeForm({ input, onChange }: PresetModeFormProps) {
  const handlePresetSelect = (presetId: WorldPreset) => {
    const preset = WORLD_PRESETS.find(p => p.id === presetId)
    if (!preset) return
    
    onChange({
      ...input,
      presetType: presetId,
      parameters: preset.parameters,
      genres: preset.defaultGenres || [],
      worldScale: (preset.defaultScale || 'country') as any,
      uniqueElements: preset.defaultElements,
    })
  }
  
  const selectedPreset = WORLD_PRESETS.find(p => p.id === input.presetType)
  
  return (
    <div className="space-y-4">
      <Alert>
        <Info className="h-4 w-4" />
        <AlertDescription>
          プリセットを選ぶと、一般的でよく使われる世界観を簡単に生成できます。
          創作の基盤として使いやすい、独創的すぎない世界が作られます。
        </AlertDescription>
      </Alert>
      
      <div>
        <Label>プリセットを選択</Label>
        <div className="grid grid-cols-2 gap-3 mt-2">
          {WORLD_PRESETS.map((preset) => (
            <button
              key={preset.id}
              onClick={() => handlePresetSelect(preset.id)}
              className={`
                p-4 text-left border rounded-lg transition-colors
                ${input.presetType === preset.id
                  ? 'border-primary bg-primary/5'
                  : 'border-border hover:bg-accent'
                }
              `}
            >
              <div className="font-semibold">{preset.name}</div>
              <div className="text-sm text-muted-foreground mt-1">
                {preset.description}
              </div>
            </button>
          ))}
        </div>
      </div>
      
      {selectedPreset && (
        <div className="space-y-2">
          <Label>プリセット設定値</Label>
          <div className="text-sm space-y-1 p-3 bg-muted rounded-lg">
            <div>魔法レベル: {selectedPreset.parameters.magicLevel}/10</div>
            <div>科学技術: {selectedPreset.parameters.scienceLevel}/10</div>
            <div>文明: {selectedPreset.parameters.civilizationLevel}/10</div>
            <div>危険度: {selectedPreset.parameters.dangerLevel}/10</div>
            <div>独自性: {selectedPreset.parameters.uniquenessLevel}/10</div>
          </div>
        </div>
      )}
      
      <div>
        <Label htmlFor="presetCustomizations">追加カスタマイズ（オプション）</Label>
        <Textarea
          id="presetCustomizations"
          placeholder="プリセットに追加したい要素があれば入力..."
          value={input.presetCustomizations?.join('\n') || ''}
          onChange={(e) => onChange({
            ...input,
            presetCustomizations: e.target.value.split('\n').filter(Boolean)
          })}
          rows={3}
        />
      </div>
    </div>
  )
}